import OpenSeadragon from 'openseadragon';

export const centerOnResult = (viewer, result) => {
  if (!viewer || !result) return;

  const viewport = viewer.viewport;
  const item = viewer.world.getItemAt(0);

  const xMin = result.x;
  const yMin = result.y;
  const xMax = result.x + result.width;
  const yMax = result.y + result.height;

  const topLeft = item.imageToViewportCoordinates(xMin, yMin);
  const bottomRight = item.imageToViewportCoordinates(xMax, yMax);

  const marginFactor = 4;
  const width = (bottomRight.x - topLeft.x) * marginFactor;
  const height = (bottomRight.y - topLeft.y) * marginFactor;

  const bounds = new OpenSeadragon.Rect(
    topLeft.x - (width - (bottomRight.x - topLeft.x)) / 2,
    topLeft.y - (height - (bottomRight.y - topLeft.y)) / 2,
    width,
    height
  );

  viewport.fitBounds(bounds, false);
};
